var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.classNames,attrs:{"aria-label":_vm.isPrevious ? 'Previous Month' : 'Next Month',"aria-hidden":"true"},on:{"click":function($event){$event.preventDefault();return _vm.handleScrollButtonPress(_vm.isPrevious ? -1 : 1)}}},[(_vm.direction === 'prev')?_c('ChevronLeftIcon'):_c('ChevronRightIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }